import { Host, h } from "@stencil/core";
const EXPANDABLE = "expandable";
/**
 * @deprecated Use the `ch-accordion-render` instead
 *
 * @part accordion__expandable - The container of the accordion content
 *
 * @slot header - The component to be displayed in the header of the control
 * @slot content - The component to be displayed as the content of the accordion (below the header)
 */
export class Accordion {
    constructor() {
        this.accessibleDescription = "";
        this.accessibleName = "";
        this.expanded = false;
    }
    /**
     * Fired when the content is expanded or collapsed
     */
    expandedChange;
    toggleExpanded = () => {
        const newExpandedValue = !this.expanded;
        this.expanded = newExpandedValue;
        this.expandedChange.emit(newExpandedValue);
    };
    render() {
        return (h(Host, { key: '655334ea000bb528fc1fa2ee5de598d5e7c8f099' }, h("button", { key: '0dde931a8e1e7185390659e16760807fcb9f946b', "aria-controls": EXPANDABLE, "aria-expanded": this.expanded.toString(), "aria-label": this.accessibleName, "aria-description": this.accessibleDescription || undefined, class: "header", part: "accordion__header", type: "button", onClick: this.toggleExpanded }, h("slot", { key: '23a7b415e1d6685bfa758f3090f9322fc451155f', name: "header" }), h("div", { key: '1b52c2ec38b38be88f1a8a3fd4c8a51458d8d335', "aria-hidden": "true", class: { chevron: true, "chevron--expanded": this.expanded }, part: "accordion__chevron" })), h("div", { key: 'ab9a88b8faccf2825ccd903ade22c7c42ea7cae1', id: EXPANDABLE, class: { expandable: true, expanded: this.expanded }, part: "accordion__expandable" }, h("slot", { key: '99e85c5641bdeb9b9d63e5e7538039a8fbcea8ab', name: "content" }))));
    }
    static get is() { return "ch-accordion"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["accordion.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["accordion.css"]
        };
    }
    static get properties() {
        return {
            "accessibleDescription": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The description of the entity."
                },
                "attribute": "accessible-description",
                "reflect": false,
                "defaultValue": "\"\""
            },
            "accessibleName": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The name of the entity."
                },
                "attribute": "accessible-name",
                "reflect": false,
                "defaultValue": "\"\""
            },
            "expanded": {
                "type": "boolean",
                "mutable": true,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "`true` if the accordion is expanded."
                },
                "attribute": "expanded",
                "reflect": false,
                "defaultValue": "false"
            }
        };
    }
    static get events() {
        return [{
                "method": "expandedChange",
                "name": "expandedChange",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Fired when the content is expanded or collapsed"
                },
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                }
            }];
    }
}
